import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading, checkAuth } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // If user data passed from AuthCallback, skip auth check
    if (location.state?.user) {
      return;
    }

    // Re-check auth if no user and not loading
    if (!user && !loading) {
      checkAuth();
    }
  }, [location.state, checkAuth, user, loading]);

  // Still loading - show loading spinner
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Not authenticated - redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !user.is_platform_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  // Authenticated - render children
  return children;
}

export default ProtectedRoute;
